import type { SparePart } from "@/mocks/products";
import { imageFor } from "@/lib/productImages";

export function enquireHref(part: SparePart, includePrice: boolean): string {
  const params = new URLSearchParams({
    category: part.category,
    part: `${part.make} ${part.model} ${part.name}`,
    make: part.make,
    model: part.model,
    year: part.yearRange,
    ...(includePrice ? { price: part.price } : {}),
    desc: part.description,
    image: imageFor(part, 0),
  });
  return `/contact-us?${params.toString()}`;
}